<template>
  <div class="report-info-block__wrapper">
    <div class="report-info-block__label">
      {{ label }}
    </div>

    <VueSkeletonLoader
      v-if="loading"
      animation="wave"
      :color="'#bec3d8'"
      :height="20"
      :radius="'2'"
      type="rect"
    />
    <div
      v-else-if="$slots.value"
      class="report-info-block__slot-value"
    >
      <slot name="value" />
    </div>
    <div v-else>
      <div
        class="report-info-block__value-wrapper"
        :class="{
          'report-info-block__value-wrapper--ellipsis': ellipsisValue,
        }"
        @click="$emit('clickedValue')"
      >
        <div
          class="report-info-block__value"
          :class="{
            'report-info-block__value--ellipsis': ellipsisValue,
          }"
        >
          {{ value || '–' }}
        </div>

        <div
          v-if="rate"
          v-popover:tooltip.top="
            rateTime ? `${priceMessage(rateTime, rateTimestamp)}` : null
          "
          class="report-info-block__price"
        >
          {{ formatByPrice(rate) }}
        </div>
        <div v-if="withCopy && value">
          <gl-icon
            class="pointer"
            :height="20"
            name="copy-gray"
            :width="20"
            @click="copy(value)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import GlIcon from '@/components/gl-icon'
import VueSkeletonLoader from 'skeleton-loader-vue'
// Utils
import { formatByPrice, priceMessage } from '@/utils/format-by-price'
import { toClipBoard } from '@/utils/helpers'
import { copyText } from '@/utils/copy-text'

export default {
  name: 'InfoBlock',
  components: {
    VueSkeletonLoader,
    GlIcon,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    withCopy: {
      type: Boolean,
      default: false,
    },
    ellipsisValue: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    rate: {
      type: [String, Number],
      default: '',
    },
    rateTime: {
      type: [String],
      default: '',
    },
    rateTimestamp: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    priceMessage,
    toClipBoard,
    formatByPrice,
    copyText,
    copy(value) {
      this.copyText(value).then(() => {
        this.$toast.add({
          severity: 'info',
          summary: 'Success Message',
          detail: 'Copied!',
          life: 3000,
        })
      })
    },
  },
}
</script>

<style>
.report-info-block__wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.report-info-block__value-wrapper,
.report-info-block__slot-value {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 4px;
}
.report-info-block__label {
  color: var(--Basic-700, rgba(9, 21, 64, 0.56));
  font-family: var(--Family-Montserrat, Montserrat);
  font-size: var(--Size-S, 12px);
  font-weight: 500;
  line-height: var(--Line-Height-S, 16px);
}
.report-info-block__value {
  color: var(--Basic-900, #091540);
  font-size: var(--Size-M, 14px);
  font-weight: 600;
  line-height: var(--Line-Height-L, 20px);
  letter-spacing: var(--Letter-Spacing-S, -0.2px);
}
.report-info-block__price {
  color: var(--Basic-700, rgba(9, 21, 64, 0.56));
  font-size: var(--Size-XS, 10px);
  font-weight: 600;
  line-height: 13px;
  padding-bottom: 2px;
}

.report-info-block__value-wrapper--ellipsis {
  align-items: flex-start;
  flex-wrap: nowrap;
}
.report-info-block__value--ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
